module.exports = __webpack_public_path__ + "static/media/ic_questionnaire_info.871f4aef.svg";